import { createAction, props } from '@ngrx/store';

export const loadAcknowledgePaymentRunByEfts = createAction(
  '[AcknowledgePaymentRunByEft] Load AcknowledgePaymentRunByEfts',
  props<{ request: { businessId: string; businessPaymentRunId: string } }>()
);

export const loadAcknowledgePaymentRunByEftsSuccess = createAction(
  '[AcknowledgePaymentRunByEft] Load AcknowledgePaymentRunByEfts Success',
  props<{ response: string }>()
);

export const loadAcknowledgePaymentRunByEftsFailure = createAction(
  '[AcknowledgePaymentRunByEft] Load AcknowledgePaymentRunByEfts Failure',
  props<{ error: Error | any }>()
);
